import axios from "axios";
import {
  GET_NIC_NETWORK_API,
  GET_NIC_NETWORK_ADAPTER_TYP_API,
  GET_OSTYPES_API,
  GET_OSVERSIONS_API,
  GET_VAPP_TEMPLATES,
  GET_VM_DETAILS_API,
  GET_NIC_IP_MODES_API,
  GET_VAPP_TEMPLATES_VM_DETAILS_API,
  CREATE_COURSE_DEFINITION,
  UPDATE_COURSE_DEFINITION,
  PUBLISH_COURSE_DEFINITION,
  VIEW_COURSE_DEFINITION_API,
  STOP_API,
  START_API,
  MOUNT_ISO_API,
  UNMOUNT_ISO_API,
} from "../../../../../common/apiEndPoint/apiEndPoint";
import { config } from "../../../../../common/authentication/config";
import AuthProvider from "../../../../../common/authentication/authService";

const SITE_ID = config.SITE_ID;
export const cookieVal = () => {
  const cookie = AuthProvider()?.getCookie("XSRF-TOKEN");
  // const cookie = localStorage['XSRF-TOKEN'];
  if (cookie !== "") {
    return cookie;
  }
};
/**
 * Function to get vApp templates from the API
 * @param requestParams - Authorization parameters
 * @returns Promise with API response
 */

export const getvAppTemplatesAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_VAPP_TEMPLATES}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};

export const getOSListApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_OSTYPES_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getOSVersionsApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_OSVERSIONS_API}/${requestParams?.osId}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getNicNetworkApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_NETWORK_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getNicNetworkAdapterTypeApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_NETWORK_ADAPTER_TYP_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getNicIpModesApi = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_NIC_IP_MODES_API}`, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {}
};
export const getVmDetailsAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${GET_VM_DETAILS_API}/${requestParams?.vAppTemplateId}?pageNo=${requestParams?.pageNo}&pageSize=${requestParams?.pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};
export const getVappTemplatesAndVmDetailsAPI = async (requestParams: any) => {
  const SEARCH_TYPE_MAP: Record<string, number> = {
    templateName: 0,
    vmName: 1,
    osType: 2,
  };
  const params = new URLSearchParams({
    pageNo: String(requestParams?.pageNo || 1),
    pageSize: String(requestParams?.pageSize || 10),
  });

  if (
    requestParams?.searchType &&
    SEARCH_TYPE_MAP[requestParams.searchType] !== undefined
  ) {
    params.append(
      "searchBy",
      String(SEARCH_TYPE_MAP[requestParams.searchType]),
    );
  }
  if (requestParams?.searchQuery) {
    params.append("searchValue", requestParams.searchQuery);
  }
  if (requestParams?.sortBy !== undefined && requestParams?.sortBy !== null) {
    params.append("sortBy", requestParams.sortBy);
  }
  if (
    requestParams?.sortOrder !== undefined &&
    requestParams?.sortOrder !== null
  ) {
    params.append("sortOrder", requestParams.sortOrder);
  }
  const url = `${GET_VAPP_TEMPLATES_VM_DETAILS_API}?${params.toString()}`;
  try {
    const res: any = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: SITE_ID,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error: any) {
    if (error.response?.status === 404 || error.response?.status === 400) {
      return {
        status: error.response?.status,
        data: {
          vAppTemplates: [],
        },
      };
    }
    throw error;
  }
};
export const saveCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${CREATE_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const updateCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.put(
      `${UPDATE_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const publishCourseDefinitionAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${PUBLISH_COURSE_DEFINITION}`,
      requestParams.payload,
      {
        headers: {
          Accept: "application/json;version=36.3",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    throw error;
  }
};
export const getCourseDataByIdAPI = async (requestParams: any) => {
  try {
    const res: any = await axios.get(
      `${VIEW_COURSE_DEFINITION_API}/${requestParams?.courseId}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: SITE_ID,
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {}
};

export const vmPowerToggleAPI = async (
  requestParams: any,
) => {
  if (!requestParams?.payload) {
    throw new Error("Invalid request payload");
  }

  const { payload } = requestParams;
  const apiEndpoint = payload?.mode === "on" ? START_API : STOP_API;
  try {
    const res: any = await axios.post(`${apiEndpoint}`, "", {
      headers: {
        vmID: payload?.vmId?.toString() || "",
        Authorization: `Bearer ${payload?.authorization}`,
        siteId: payload?.siteId,
        courseSiteId: payload?.courseSiteId,
        tenantId: payload?.orgId,
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const mountISOAcademyApi = async (requestParams: any) => {
  try {
    const res: any = await axios.post(
      `${MOUNT_ISO_API}`,
      requestParams?.isoData,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.authorization}`,
          siteId: requestParams?.siteId,
          orgId: requestParams?.orgId,
          vmId: requestParams?.vmId,
          tenantId: requestParams?.tenantId,
          isAcademyDraftOrgs: "true",
          "X-XSRF-TOKEN": cookieVal(),
        },
      },
    );
    return res;
  } catch (error) {
    return error;
  }
};

export const unMountISOAcademyApi = async (requestParams: any) => {
  try {
    const res: any = await axios.post(`${UNMOUNT_ISO_API}`, "", {
      headers: {
        Authorization: `Bearer ${requestParams?.authorization}`,
        siteId: requestParams?.siteId,
        tenantId: requestParams?.tenantId,
        orgId: requestParams?.orgId,
        vmId: requestParams?.vmId,
        isAcademyDraftOrgs: "true",
        "X-XSRF-TOKEN": cookieVal(),
      },
    });
    return res;
  } catch (error) {
     return error;
  }
};
